// extracted by mini-css-extract-plugin
export default {"info":"EmailStep_info__gK64Z","form":"EmailStep_form__26DBy","actions":"EmailStep_actions__oP9ZB"};